module.exports = __webpack_public_path__ + "img/便捷统一的系统管理@2x.f7149372.png";